<style lang="scss" src='./SensorList.scss' scoped ></style>
<template src="./SensorList.html"></template>

<script>
import VuePullRefresh from 'vue-pull-refresh';
import {
  mapState,
  mapActions,
  mapMutations,
  mapGetters,
} from 'vuex';
import { GetSensorRSSI, MoveToInventory } from '@/api/api';
import CommonComponent from '@/components/utils/CommonComponent.vue';
import RefreshButton from '@/components/refreshButton/RefreshButton.vue';

export default {
  name: 'Sensors',
  extends: CommonComponent,
  components: {
    'vue-pull-refresh': VuePullRefresh,
    RefreshButton
  },
  data() {
    return ({
      sensorSelected: {},
      maxHeightSensor: 600,
      statusSelected: null,
      sensorUpdateInterval: null,
      canSeeLastReading: false,
      invalidText: this.$t('general.invalid'),
    });
  },
  computed: {
    ...mapState('SensorList', {
      sensors: (state) => state.sensors,
      sensorStatus: (state) => state.sensorStatus,
      sensorStatusFilter: (state) => state.sensorStatusFilter,
      rssiRanges: (state) => state.rssiRanges,
      loading: (state) => state.loading,
    }),
    ...mapGetters('SensorList', ['sensorsFiltered']),
    ...mapState(['course']), 
    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
  },
  watch: {
    course() {
      this.loadData();
    },
  },
  methods: {

    showFirmwareVersion(sensor) {
      if(sensor.version && 
          sensor.status_id === this.consts.SensorStatus.DEPLOY_PENDING &&
          this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
        return ' (' + sensor.version + ')';
      }
      return '';
    },

    async moveToInventory() {
      await MoveToInventory(this.sensorSelected.sensor_id).then( resetSensor => {
        this.$refs.modalLowRssi.hide()
        this.updateSensor(resetSensor);
      });
      
    },

    refreshSensorList() {
      const self = this;
      // eslint-disable-next-line
      return new Promise(async function (resolve, reject) {
        await self.loadSensors();
        resolve('ok');
      });
    },

    startIntervalToRefreshSensors() {
      this.sensorUpdateInterval = window.setInterval(this.redo, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

    redo(){
      // Pass true to hide loading
      this.loadSensors(true)
    },

    refresh (){
      this.loadSensors()
    },
    
    getRssiIcon(sensor) {
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
    },

    loadData() {
      this.loadSensors();
      this.loadSensorStatus();
    },

    async selectSensor(sensor) {
      if (sensor) {
        this.sensorSelected = sensor;
        this.$store.commit('setSensor', sensor);

        switch (sensor.status_id) {
          case this.consts.SensorStatus.DEPLOYING_LOW_RSSI:
            this.setLoading({ ...this.loading, global: true });
            await GetSensorRSSI(sensor.sensor_id).then((response) => {
              sensor.rssi = response.rssi;
              if (response.aceptable_signal) {
                this.$refs.modalLowRssi.hide();
                this.$router.push('/sensor-provisioning');
              } else {
                this.$refs.modalLowRssi.show();
              }
            });
            this.setLoading({ ...this.loading, global: false });
            break;
          case this.consts.SensorStatus.DEPLOYING:
            this.$router.push('/sensor-provisioning');
            break;
          case this.consts.SensorStatus.DEPLOY_PENDING:
            this.$router.push('/sensor-offline');
            break;
          case this.consts.SensorStatus.DEPLOYED:
          case this.consts.SensorStatus.CHECK:
            this.$router.push('/sensor-details');
          // eslint-disable-next-line
          default:
            break;
        }
      }
    },

    adjustSensorListHeight() {
      const self = this;
      // eslint-disable-next-line
      const sensorHeightInterval = setInterval(function() {
        if (self.$refs.sensorsContainer) {
          self.maxHeightSensor = 
            (window.innerHeight - 60) - (self.$refs.sensorsContainer.getBoundingClientRect().top);
        }
      }, 0);
      // eslint-disable-next-line
      setTimeout(function() {
        clearInterval(sensorHeightInterval);
      }, 5000);
    },

    ...mapActions('SensorList', ['loadSensors', 'loadSensorStatus']),
    ...mapMutations('SensorList', ['setLoading', 'setSensorStatusFilter', 'setSensors', 'updateSensor']),
  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.setShowMenu(true);
    this.setShowBackground(true);
  },

  mounted() {
    this.adjustSensorListHeight();
    this.loadData();
    this.startIntervalToRefreshSensors();
    this.canSeeLastReading = this.G_canDo(this.consts.Security.Action.SEE_ONLY_LAST_READING, this.user, null);
  },

  beforeDestroy() {
    window.clearInterval(this.sensorUpdateInterval);
  },
};
</script>
